export enum ItemCategory {
  Weapon = "weapon",
  WeaponComponents = "weapon_components",
  Products = "products",
  Tech = "tech",
  Clothes = "clothes",
  Med = "med",
  Resources = "resources",
  Capacity = "capacity",
  Quest = "quest",
}
